import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import des traductions
import translationFR from './locales/fr/translation.json';
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import translationIT from './locales/it/translation.json';

const resources = {
  fr: {
    translation: translationFR
  },
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  },
  it: {
    translation: translationIT
  }
};

i18n
  // Détection automatique de la langue
  .use(LanguageDetector)
  // Intégration avec React
  .use(initReactI18next)
  // Configuration
  .init({
    resources,
    
    // Langue par défaut et initiale
    lng: 'fr',
    fallbackLng: 'fr',
    
    // Langues supportées
    supportedLngs: ['fr', 'en', 'es', 'it'],
    
    // Détection intelligente de la langue
    detection: {
      // Ordre de détection : localStorage d'abord, puis navigator, puis IP detection service
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Clé pour le localStorage
      lookupLocalStorage: 'i18nextLng',
      // Cache la langue détectée
      caches: ['localStorage'],
      // Exclude cookie for simplicity
      excludeCacheFor: ['cimode'],
    },

    // Options d'interpolation
    interpolation: {
      // React échappe déjà les valeurs
      escapeValue: false,
    },

    // Configuration pour le développement
    debug: false,

    // Namespace par défaut
    defaultNS: 'translation',
    
    // Séparateur pour les clés imbriquées
    keySeparator: '.',
    
    // Séparateur pour les namespaces
    nsSeparator: ':',
  });

export default i18n;